import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from '../../../../../../services/helpers.service';
import { RentalsService } from '../../../../../../services/rentals.service';
import { AddEditAccessoryCategoriesComponent } from '../../../../../modals/rentals/add-edit-accessory-categories/add-edit-accessory-categories.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rental-accessory-categories',
  templateUrl: './rental-accessory-categories.component.html',
  styleUrls: ['./rental-accessory-categories.component.scss'],
})
export class RentalAccessoryCategoriesComponent implements OnInit {
  @Input() messageService;
  public loading: boolean = false;
  public categories: any = [];

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    public modalService: NgbModal,
  ) {}

  ngOnInit() {
    this.getCategories();
  }

  getCategories() {
    this.loading = true;
    this.rentalsService
      .getRentalAccessoryCategories(this.helpersService.getPartnerId())
      .subscribe(
        (res) => {
          this.categories = res;
          console.log(res);
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  addCategory() {
    const modalRef = this.modalService.open(
      AddEditAccessoryCategoriesComponent,
      {
        backdrop: 'static',
        windowClass: 'user-modal',
      },
    );
    modalRef.componentInstance.category = {};
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.result.then((result) => {
      this.getCategories();
    });
  }

  editCategory(category) {
    const modalRef = this.modalService.open(
      AddEditAccessoryCategoriesComponent,
      {
        backdrop: 'static',
        windowClass: 'user-modal',
      },
    );
    modalRef.componentInstance.category = category;
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.result.then((result) => {
      this.getCategories();
    });
  }
}
